import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ConfirmationDialogResponse } from './confirmation-dialog-response.enum';
import { AppBackgroundOverlayService } from '@prism/angular-shared';

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService {


    // for the user to interact with.
    response$: Subject<ConfirmationDialogResponse> = new Subject<ConfirmationDialogResponse>();


    // not to be used by the user.
    dialogDisplayed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    title$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    message$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    options$: BehaviorSubject<ConfirmationDialogResponse[]> = new BehaviorSubject<ConfirmationDialogResponse[]>([]);
    disableBackgroundOverlay$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public styleVariableScale: number = 1;

    constructor(
        private appBackgroundOverlayService: AppBackgroundOverlayService
    ) { }

    displayDialog(title: string, message: string, options: ConfirmationDialogResponse[]) {
        this.dialogDisplayed$.next(true);
        if (!this.disableBackgroundOverlay$.value) {
            this.appBackgroundOverlayService.overlayDisplayed$.next(true);
        }

        this.title$.next(title);
        this.message$.next(message);
        this.options$.next(options);
    }

    destroyDialog() {
        this.styleVariableScale = 1;
        this.dialogDisplayed$.next(false);
        this.disableBackgroundOverlay$.next(false);
        this.appBackgroundOverlayService.overlayDisplayed$.next(false);
        this.title$.next('');
        this.message$.next('');
        this.options$.next([]);
        this.response$.complete();
        this.response$ = new Subject<ConfirmationDialogResponse>();
    }

}